import { pipe } from 'ramda';

import { IRootState } from '../../../../store/root.types';

const pathToSettingsState = (state: IRootState) => state.marketplace.settings;

export const getIsInit = pipe(pathToSettingsState, state => state.isInit);

export const getHashId = pipe(pathToSettingsState, state => state.hashId);

export const getIsDonation = pipe(pathToSettingsState, state => state.isDonation);
